import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "theme", "container", "className", "shouldRender"];
import React from 'react';
import { cnTheme } from '@carnica/themes';
import ReactDOM from 'react-dom';
import { withClientRendering } from '@beef/react/enhancers';
import { ATTRIBUTE_PORTAL_VALUE, cnBem, forwardRefWithMotionTag } from '@carnica/utils';
import { ThemeProvider } from "../ThemeProvider";
var cnThemedPortal = cnBem('portal');
var ThemedPortalRender = forwardRefWithMotionTag(function (props, ref) {
  var _window, _window$document;
  var children = props.children,
    theme = props.theme,
    _props$container = props.container,
    containerProp = _props$container === void 0 ? (_window = window) === null || _window === void 0 ? void 0 : (_window$document = _window.document) === null || _window$document === void 0 ? void 0 : _window$document.body : _props$container,
    className = props.className,
    shouldRender = props.shouldRender,
    otherProps = _objectWithoutProperties(props, _excluded);
  var container = 'current' in containerProp ? containerProp.current : containerProp;
  if (!container) {
    return null;
  }
  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(ThemeProvider, _extends({
    className: cnThemedPortal(null, [cnTheme(theme), className]),
    "data-portal": ATTRIBUTE_PORTAL_VALUE,
    initialTheme: theme,
    ref: ref
  }, otherProps, {
    "data-t-id": "modules-ThemedPortal"
  }), children), container);
});
export var ThemedPortal = withClientRendering(ThemedPortalRender);